import Submenu from "../../components/organisms/Submenu";
import { HeaderLogo } from "./header-logo";
import { ToggleDepartment } from "./toggle-department";
import { WhatsappNotification } from "./whatsapp-notification";

export function Header({ title }) {
  return (
    <>
      {/* <WhatsappNotification /> */}
      <div className="w-full flex h-20 center items-center justify-between p-4 border-b bg-white border-zinc-200/40 shadow-md">
        <div className="flex items-center justify-center gap-2">
          <HeaderLogo />
          <ToggleDepartment />
        </div>
        {title && (
          <div className="h-full flex items-end justify-center">
            <h1 className="text-2xl pl-1 flex font-medium gap-2 items-center justify-center text-scale-500">{title}</h1>
          </div>
        )}
        <div className="flex items-center justify-end gap-4">
          <Submenu />
        </div>
      </div>
    </>
  );
}
